import React from 'react';

import { Avatar, IconButton } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

import { pink } from '@mui/material/colors';

import Quill from 'quill';
import 'quill/dist/quill.bubble.css';

function TextBlockView({idx, block, allowEditing, onEdit}) {
	//console.log("TextBlockView: allowEditing = " + allowEditing);

	const quill = React.useRef();
	const dataManagerReg = React.useRef();

	function getEditorContainerName() {
		// idx is supposed to be unique among all blocks of a content
		return 'editor-container-' + idx;
	}

	function getEditorName() {
		// idx is supposed to be unique among all blocks of a content
		return 'editor-' + idx;
	}

	React.useEffect(() => {
		function addDataKeyWithoutDup(dataKeys, newDataKey) {
			// Adds newDataKey to dataKeys only when there is no duplicate
			//
			for (let i = 0; i < dataKeys.length; i++) {
				if (dataKeys[i] === newDataKey) return;
			}
			dataKeys.push(newDataKey);
		}

		function findSubs(text, dataKeys) {
			//console.log("findSubs: text = " + text);

			const startPattern = '$${';
			const endPattern = '}';

			let findings = [];
			let idx = 0;

			while (true) {
				let from = text.indexOf(startPattern, idx);
				if (from < 0) break;

				let to = text.indexOf(endPattern, from + startPattern.length);
				if (to < 0) break;

				let dataKey = text.substring(from + startPattern.length, to);
				findings.push({ from: from, to: to, key: dataKey });

				addDataKeyWithoutDup(dataKeys, dataKey);

				idx = to + 1;
			}
			//console.log("findings = " + JSON.stringify(findings));
			return findings;
		}

		function substituteData(ops, subs, dataValues) {
			console.log("substituteData: dataValues = " + JSON.stringify(dataValues));

			let dataKeys = [];
			let newOps = [];

			for (let i = 0; i < subs.length; i++) {
				const text = ops[i].insert;

				let newText = "";
				let idx = 0;

				for (let j = 0; j < subs[i].length; j++) {
					newText += text.substring(idx, subs[i][j].from);
					newText += dataValues[subs[i][j].key];
					idx = subs[i][j].to + 1;
				}
				newText += text.substring(idx);

				//console.log("newText = " + newText);
				newOps.push({
					insert: newText,
					attributes: ops[i].attributes
				});
			}
			return newOps;
		}

		async function setEditorContents(data) {
			console.log("setEditorContents: data = " + JSON.stringify(data));

			if (Array.isArray(data.ops)) {
				let subs = [];
				let dataKeys = [];

				for (let i = 0; i < data.ops.length; i++) {
					subs.push(findSubs(data.ops[i].insert, dataKeys));
				}

				if (dataKeys.length > 0) {
					dataManagerReg.current = global.dataManager.register(
						dataKeys,
						function onChange(dataValues) {
							// note that data here is always the same as that passed to setEditorContents
							// regardless how many times onChange is called
							//
							let newOps = substituteData(data.ops, subs, dataValues);
							quill.current.setContents({ ops: newOps });
						}
					);
				}
				else {
					quill.current.setContents(data);
				}
			}
		}

		let container = document.getElementById(getEditorContainerName());
		if (container) {
			let editorElm = document.createElement('div');
			editorElm.id = getEditorName();
			container.appendChild(editorElm);

			const fontFamilies = [
				'다시 시작해', '배민 주아체', '우리딸 손글씨', '카페24써라운드에어',
				'배민 을지로체', '여기어때잘난체', '카페24숑숑', '카페24써라운드',
				'노토산스 Black', '노토산스 Bold', '노토산스 Light', '노토산스 Medium', '노토산스 Regular',
				'노토세리프 Black', '노토세리프 Bold', '노토세리프 Light', '노토세리프 Medium',
				'노토세리프 Regular',
			];
			const fontSizes = ['10', '11', '12', '14', '18', '24', '32', '42'];
			const lineHeights = ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100'];

			let options = {
				modules: {},
				readOnly: true,
			};
			quill.current = new Quill('#' + getEditorName(), options);

/*
			let font = Quill.import('attributors/style/font');
			font.whitelist = fontFamilies;
			Quill.register(font, true);

			let fontSize = Quill.import('attributors/style/size');
			fontSize.whitelist = undefined;
			Quill.register(fontSize, true);

			let Parchment = Quill.import('parchment');

			const lineHeightCfg = {
				scope: Parchment.Scope.INLINE,
				//whitelist: lineHeights
			};
			const lineHeightStyle = new Parchment.Attributor.Style('lineheight', 'line-height', lineHeightCfg);
			Quill.register(lineHeightStyle, true);
*/
			setEditorContents(block.data);
		}

		return function cleanup() {
			if (dataManagerReg.current) {
				global.dataManager.unregister(dataManagerReg.current);
			}

			let container = document.getElementById(getEditorContainerName());
			if (container) {
				while (container.firstChild) {
					container.removeChild(container.firstChild);
				}
			}
		};

	}, [block.data]);

	function getEditButton() {
		if (allowEditing) {
			return (
				<IconButton
					style={{
						position:"absolute",
						top:25,
						left:25,
					}}
					size="large"
					onClick={e => onEdit(block)}
				>
					<Avatar sx={{bgcolor:pink[500]}}>
						<EditIcon />
					</Avatar>
				</IconButton>
			);
		}
		return null;
	}

	const style = {
		backgroundColor: block.backgroundColor,
		//border: "2px solid red",
	};

	return (
		<div style={{width:'100%', position:'relative'}}>
			<div id={block.name} style={style}>
				<div id={getEditorContainerName()} style={{width:'100%'}}/>
			</div>
			{getEditButton()}
		</div>
	);
}

export default TextBlockView;
